module.exports = __webpack_public_path__ + "static/media/account.11c69cad.svg";